import Layout from '@/baseLayout/LayoutPage'
console.log("Layout",Layout)
/**
 * 管理员路由
  */

const adminRole = "admin"
const adminGroupOne = "参赛管理"
const adminGroupTwo = "基础管理"
const adminGroupThree = "初赛评审"
const adminGroupFour = "复赛评审"
const adminGroupFive = "系统管理"
export const routesAd = {
    path: "/admin",
    name:"admin",
    component:Layout,
    redirect:"/admin/teamsList",
    children:[
            // 参赛管理 classicOne
            {
                path: 'teamsList',
                component: () => import(/* webpackChunkName: "about" */ '../views/admin/TeamsListView.vue'),
                meta:{title:"参赛队信息管理",menuShow:true,"group":adminGroupOne,'role':adminRole}
            },
            {
                path: 'numbers',
                component: () => import(/* webpackChunkName: "about" */ '../views/admin/NumbersView.vue'),
                meta:{title:"参赛队员管理",menuShow:true,"group":adminGroupOne,'role':adminRole}
            },
            {
                path: 'teachersView',
                component: () => import(/* webpackChunkName: "about" */ '../views/admin/TeachersView.vue'),
                meta:{title:"辅导老师管理",menuShow:true,"group":adminGroupOne,'role':adminRole}
            },
            {
                path: 'entry',
                component: () => import(/* webpackChunkName: "about" */ '../views/admin/EntryView.vue'),
                meta:{title:"参赛作品管理",menuShow:true,"group":adminGroupOne,'role':adminRole}
            },
        {
            path: 'entrydetail',
            component: () => import(/* webpackChunkName: "about" */ '../views/admin/EntryDetailView.vue'),
            meta:{title:"参赛作品详情",menuShow:false,"group":adminGroupOne,'role':adminRole}
        },
            {
                path: 'downloadDocs',
                component: () => import(/* webpackChunkName: "about" */ '../views/admin/DownloadDocs.vue'),
                meta:{title:"参赛文件管理",menuShow:true,"group":adminGroupOne,'role':adminRole}
            },
        {
            path: 'repechageentrylist',
            component: () => () => import(/* webpackChunkName: "about" */ '../views/admin/RepechageResultView.vue'),
            meta:{title:"复赛文件信息",menuShow:true,"group":adminGroupOne,'role':adminRole}
        },
        {
            path: 'repechageentrydetail',
            component: () => () => import(/* webpackChunkName: "about" */ '../views/admin/RepechageEntryDetailView.vue'),
            meta:{title:"复赛文件信息",menuShow:false,"group":adminGroupOne,'role':adminRole}
        },
// 专家管理
            {
                path: 'specialist',
                component: () => import(/* webpackChunkName: "about" */ '../views/admin/SpecialistView.vue'),
                meta:{title:"专家管理",menuShow:true,'role':adminRole}
            },
//    基础管理 adminGroupTwo
            {
                path: 'information',
                component: () => import(/* webpackChunkName: "about" */ '../views/admin/InformationView.vue'),
                meta:{title:"大赛信息管理",menuShow:true,"group":adminGroupTwo,'role':adminRole}
            },
            {
                path: 'typemanagement',
                component: () => import(/* webpackChunkName: "about" */ '../views/admin/TypemanagementView.vue'),
                meta:{title:"选题类型管理",menuShow:true,"group":adminGroupTwo,'role':adminRole}
            },
            {
                path: 'schools',
                component: () => import(/* webpackChunkName: "about" */ '../views/admin/SchoolsView.vue'),
                meta:{title:"学校信息管理",menuShow:true,"group":adminGroupTwo,'role':adminRole}
            },
        {
            path: 'zone',
            component: () => () => import(/* webpackChunkName: "about" */ '../views/admin/zoneView.vue'),
            meta:{title:"大赛赛区管理",menuShow:true,"group":adminGroupTwo,'role':adminRole}
        },
//    初赛评审 adminGroupThree
            {
                path: 'preliminarygroup',
                component: () => import(/* webpackChunkName: "about" */ '../views/admin/PreliminarygroupView.vue'),
                meta:{title:"初赛分组管理",menuShow:true,"group":adminGroupThree,'role':adminRole}
            },
            {
                path: 'preliminarymark',
                component: () => import(/* webpackChunkName: "about" */ '../views/admin/PreliminarymarkView.vue'),
                meta:{title:"初赛打分标准",menuShow:true,"group":adminGroupThree,'role':adminRole}
            },
            {
                path: 'preliminaryResult',
                component: () => import(/* webpackChunkName: "about" */ '../views/admin/PreliminaryResultView.vue'),
                meta:{title:"初赛评分结果",menuShow:true,"group":adminGroupThree,'role':adminRole}
            },
        {
            path: 'sendMessage',
            component: () => import(/* webpackChunkName: "about" */ '../views/admin/SendMessage.vue'),
            meta:{title:"短信通知结果",menuShow:true,"group":adminGroupThree,'role':adminRole}
        },
            //复赛评分 adminGroupFour
            {
                path: 'repechagegroup',
                component: () => import(/* webpackChunkName: "about" */ '../views/admin/RepechagegroupView.vue'),
                meta:{title:"复赛分组管理",menuShow:true,"group":adminGroupFour,'role':adminRole}
            },
            {
                path: 'repechagemark',
                component: () => import(/* webpackChunkName: "about" */ '../views/admin/RepechagemarkView.vue'),
                meta:{title:"复赛打分标准",menuShow:true,"group":adminGroupFour,'role':adminRole}
            },
            {
                path: 'repechageResult',
                component: () => import(/* webpackChunkName: "about" */ '../views/admin/RepechageResultView.vue'),
                meta:{title:"复赛评分结果",menuShow:true,"group":adminGroupFour,'role':adminRole}
            },
            // 系统管理 adminGroupFive
            // {
            //     path: 'organization',
            //     component: () => import(/* webpackChunkName: "about" */ '../views/admin/OrganizationView.vue'),
            //     meta:{title:"组织机构",menuShow:true,"group":adminGroupFive,'role':adminRole}
            // },
            {
                path: 'user',
                component: () => import(/* webpackChunkName: "about" */ '../views/admin/UserView.vue'),
                meta:{title:"用户管理",menuShow:true,"group":adminGroupFive,'role':adminRole}
            },
            {
                path: 'roles',
                component: () => import(/* webpackChunkName: "about" */ '../views/admin/RolesView.vue'),
                meta:{title:"角色权限",menuShow:true,"group":adminGroupFive,'role':adminRole}
            },
            {
                path: 'logs',
                component: () => import(/* webpackChunkName: "about" */ '../views/admin/LogsView.vue'),
                meta:{title:"操作日志",menuShow:true,"group":adminGroupFive,'role':adminRole}
            },
            // {
            //     path: 'sysinfo',
            //     component: import(/* webpackChunkName: "about" */ '../views/admin/SysinfoView.vue'),
            //     meta:{title:"系统信息",menuShow:true,"group":adminGroupFive,'role':adminRole}
            // },
    ]
}


